// Thin wrapper around gtag. Safe to call before gtag has loaded (SSR, blocked
// script, ad blocker) — it just becomes a no-op instead of throwing.
export const trackEvent = (name, params = {}) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", name, params);
};
